// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YbR3","right":"styles_right__3mSQ7"};